import React from 'react';
import Icon from 'antd/lib/icon';

const Columns = () => {
  return [
    {
      title: 'Report metrics',
      dataIndex: 'report_metric',
    },
    {
      title: 'Chart type',
      dataIndex: 'chart_type',
    },
    {
      title: 'Level 0',
      dataIndex: 'level0',
      align: 'center',
      render: (text) => text ? <Icon twoToneColor='#fa8c15' type="check-square" theme="twoTone" /> : '',
    },
    {
      title: 'Level 1',
      dataIndex: 'level1',
      align: 'center',
      render: (text) => text ? <Icon twoToneColor='#fa8c15' type="check-square" theme="twoTone" /> : '',
    },
    {
      title: 'Level 2',
      dataIndex: 'level2',
      align: 'center',
      render: (text) => text ? <Icon twoToneColor='#fa8c15' type="check-square" theme="twoTone" /> : '',
    },
    {
      title: 'Level 3',
      dataIndex: 'level3',
      align: 'center',
      render: (text) => text ? <Icon twoToneColor='#fa8c15' type="check-square" theme="twoTone" /> : '',
    },
  ];
};

export default Columns;
